import { Fragment, useState, useEffect } from 'react'

// third party components
import { Dialog, Transition } from '@headlessui/react'

// styles
import styles from './index.module.scss'

import MenuEditPage from 'components/Menu/MenuEditPage'

export interface UpdateNFTModalProps<T> {
  studio: boolean
  metadata: boolean
  explorerURL: any
  merchToggle: boolean
  isCreatedNft: boolean
  setShowNftMeta: any
  setCreateMerchModal: any
  setRemoveMerchModal: any
  setOpenShareModal: any
  open: boolean
  onClose: () => void
}

const NftMenuEditModal = <T,>({
  open,
  onClose,
  studio,
  metadata,
  explorerURL,
  merchToggle,
  isCreatedNft,
  setShowNftMeta,
  setCreateMerchModal,
  setRemoveMerchModal,
  setOpenShareModal,
}: UpdateNFTModalProps<T>) => {
  const closeModal = () => {
    onClose()
  }

  const [show, setShow] = useState(false)

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setShow(true)
      }, 100)
    }
  }, [open])

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className={styles.container} onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={styles.bgView} />
        </Transition.Child>
        <div className="fixed inset-0" onClick={() => closeModal()}>
          <div className={`${styles.modalView} ${show ? styles.show : styles.hide}`}>
            <div className="w-full h-full">
              <MenuEditPage
                studio={studio}
                metadata={metadata}
                merchToggle={merchToggle}
                explorerURL={explorerURL}
                isCreatedNft={isCreatedNft}
                setShowNftMeta={setShowNftMeta}
                setCreateMerchModal={setCreateMerchModal}
                setRemoveMerchModal={setRemoveMerchModal}
                setOpenShareModal={setOpenShareModal}
              />
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default NftMenuEditModal
